import AppError from '@/components/App/AppError.vue'

const Error = {
  install(Vue) {
    this.EventBus = new Vue()
    Vue.component('app-error', AppError)
    Vue.prototype.$error = {
      show(params) {
        Error.EventBus.$emit('show', params)
      }
    }
  }
}

export default Error